import { gql } from '@/__generated__';

/** Batería registrada de la compuerta (caché de última lectura): el respaldo de la lectura en vivo. */
export const GET_GATE_LAST_BATTERY = gql(`#graphql
  query GetGateLastBattery($gateId: ID!) {
    gate(input: { id: $gateId }) {
      id
      movements2 {
        id
        lastBattery {
          value
          unit
          precision
          source
          timestamp
        }
      }
    }
  }
`);
